import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistState } from 'redux-devtools';
import { routerMiddleware } from 'react-router-redux';

import sagas from 'sagas/rootSaga';
import rootReducer from 'reducers/rootReducer';

/* eslint-disable no-process-env */

export default (history) => {
  let middlewareArr = [];
  let enhancerArr = [];

  // Saga Middleware
  const sagaMiddleware = createSagaMiddleware();
  middlewareArr.push(sagaMiddleware);

  // react-router-redux middleware (enables using its redux action creators)
  middlewareArr.push(routerMiddleware(history));

  // Add middleware to enhancerArr
  enhancerArr.push(applyMiddleware(...middlewareArr));

  // Allows marking a session as a debug_session, rehydrating appState upon refresh
  enhancerArr.push(persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)));

  // Allows use of Redux DevTools
  if (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancerArr.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }

  const enhancers = compose(...enhancerArr);
  const store = createStore(rootReducer, enhancers);

  // Run sagas
  sagaMiddleware.run(sagas);

  return store;
};
